import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// @ts-ignore - css side-effect import handled by Vite; tsc check only (no css types needed for build)
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
